
$stickyHeader = document.querySelector('.shopify-section-header-sticky');

scrollMarginTop = 0;

if ($stickyHeader) {
    scrollMarginTop += $stickyHeader.offsetHeight;
}

document.querySelectorAll('#MainContent > section').forEach(function($section) {
    $section.style.scrollMarginTop = scrollMarginTop+ 'px';
});

$allBannerButtonContainers = document.querySelectorAll('.banner__buttons');

if ($allBannerButtonContainers.length) {

    $bannerButtonContainer = $allBannerButtonContainers[0];

    $bannerButtons = $bannerButtonContainer.querySelectorAll('.button');

    $bannerButtons.forEach(function($button) {
        
        $button.addEventListener('click', function(e) {
            e.preventDefault();
            $a = e.target;

            $section = document.getElementById($a.getAttribute('href').replace('#', ''));

            if ($section) {
                $section.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }

        });

    });

}